import { addGETParams } from '../../config'
import ax from '../api'
import axInsecure from '../api-insecure'

/*
 * setRecruitment - Set a recruitment item on the server
 * @param {string} recruitmentId - The id of the recruitment item
 * @param {object} full - The full object of the recruitment item
 * @returns {object} The response from the server
 */
export const setRecruitment = async (recruitmentId, full) => {
	// Convert full object to JSON string
	const fullStr = JSON.stringify(full)
	const _url = addGETParams(`/management/recruitment/set.php`, {
		recruitment_id: recruitmentId,
		full: fullStr
	})
	return await axInsecure.post(_url)
}

/*
 * getRecruitmentList - Retrieve a list of recruitment items from the server
 * @param {object} params - Parameters to filter and paginate the recruitment list
 * @returns {object} The response from the server containing the list of recruitment
 */
export const getRecruitmentList = async (params) => {
	const _url = addGETParams(`/management/recruitment/lst.php`, params)

	return await ax.post(_url)
}

/*
 * getRecruitment - Retrieve a specific recruitment item from the server
 * @param {string} recruitment_id - The id of the recruitment item to retrieve
 * @returns {object} The response from the server containing the recruitment item
 */
export const getRecruitment = async (recruitment_id) => {
	const _url = addGETParams(`/management/recruitment/get.php`, {
		recruitment_id
	})

	return await ax.post(_url)
}
